<template>
  <header>
    <div class="at-container">
      <div class="row  at-row no-gutter">
        <div class="col-md-18">
          <div class="logo light-blue">
            <i class="iconfont">&#xe643;</i>
            {{ logo }}
            <iframe src="https://ghbtns.com/github-btn.html?user=wzs28150&repo=coolui-scroller&type=star&count=false" frameborder="0" scrolling="0" width="60px" height="20px" style="margin-left:15px; float:right;"></iframe>
          </div>
        </div>
        <div class="col-md-6">
          <at-menu mode="horizontal" :active-name="active" :router="false">
            <template v-for="(item, index) in list">
              <at-submenu
                name="item.path"
                v-if="item.children && item.children[0].children"
                :key="index"
                :class="{'at-menu__submenu--active':active == item.path}"
              >
                <template slot="title">
                  <i :class="['icon', item.meta.icon]"></i>
                  {{ item.meta.title }}
                </template>

                <at-menu-item
                  v-for="(it, ind) in item.children"
                  :name="it.children[0].meta.fullpath"
                  :to="it.children[0].meta.fullpath"
                  :key="ind"
                >
                  <i :class="['icon', it.meta.icon]"></i>
                  {{ it.meta.title }}
                </at-menu-item>
              </at-submenu>
              <at-menu-item
                v-else
                :name="item.path"
                :to="item.children[0].meta.fullpath"
                :key="index"
                :class="{'at-menu__item--active':active == item.path}"
              >
                <i :class="['icon', item.meta.icon]"></i>
                {{ item.meta.title }}
              </at-menu-item>
            </template>
          </at-menu>
          
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import instance from '@/api/config.js'
  export default {
    data() {
      return {
        active: '',
        list: [],
        logo: '',
      }
    },
    computed: {},
    created() {
      let that = this
      instance.get('router.json').then((res) => {
        // console.log(res.data)
        that.$router.addRoutes(res.data.nav)
        that.$router.options.routes.push(res.data.nav)
        that.active = that.$route.meta.parentpath[0]
        // console.log(that.active);
        that.list = res.data.nav
        that.logo = res.data.logo
      })
    },
    methods: {},
    watch: {
      $route() {
        this.active = this.$route.meta.parentpath[0]
      },
    },
  }
</script>

<style scoped lang="scss">
  header {
    background-color: #fff;
    box-shadow: 0 10px 60px 0 rgba(29, 29, 31, 0.07);
    opacity: 0.98;
    width: 100%;
    position: relative;
    z-index: 5;
    .logo {
      font-size: 22px;
      line-height: 60px;
      font-weight: bold;
      display: flex;
      align-items: center;
      i {
        font-size: 30px;
        display: block;
        margin-right: 10px;
      }
    }
    .at-menu {
      float: right;
      line-height: 60px;
      height: 60px;
    }
  }
</style>
